import { CheckCheck, Layers, Crown } from "lucide-react";
import { OBJECTIONS, TRUST_PRINCIPLES, VERIFIED_TESTIMONIALS } from "../config/brand";
import { FadeUp, LineReveal, Eyebrow } from "../components/Reveal";

const principleIcons = [CheckCheck, Layers, Crown];

export const Trust = () => (
  <section className="bg-ivory" aria-label="Why you can trust it" data-testid="trust-section">
    <div className="mx-auto max-w-[1280px] px-5 py-20 sm:px-8 lg:py-28">
      <LineReveal
        as="h2"
        lines={["Designed for real life—not", "an idealized version of it."]}
        className="font-serif text-4xl font-medium leading-[1.08] tracking-tight text-plum sm:text-5xl"
      />
      <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3">
        {TRUST_PRINCIPLES.map((p, i) => {
          const Icon = principleIcons[i];
          return (
            <FadeUp key={p.title} delay={i * 0.08}>
              <div
                data-testid={`trust-principle-${i + 1}`}
                className="h-full rounded-3xl border border-mauve/35 bg-warmwhite p-8 shadow-[0_8px_30px_rgba(90,48,73,0.04)]"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-blushcream text-plum">
                  <Icon size={19} strokeWidth={1.5} />
                </span>
                <h3 className="mt-5 text-xs font-bold uppercase tracking-[0.22em] text-plum">
                  {p.title}
                </h3>
                <p className="mt-3 font-serif text-xl italic leading-snug text-plumcharcoal/80">
                  {p.text}
                </p>
              </div>
            </FadeUp>
          );
        })}
      </div>

      <div className="mt-20">
        <FadeUp>
          <Eyebrow>Fair questions, honest answers</Eyebrow>
        </FadeUp>
        <div className="mt-8 grid grid-cols-1 gap-x-12 gap-y-8 md:grid-cols-2">
          {OBJECTIONS.map((o, i) => (
            <FadeUp key={o.q} delay={i * 0.04}>
              <div data-testid={`objection-${i + 1}`} className="border-l-2 border-mauve/50 pl-5">
                <p className="font-serif text-xl italic leading-snug text-plum">{o.q}</p>
                <p className="mt-2 text-sm leading-relaxed text-plumcharcoal/70">{o.a}</p>
              </div>
            </FadeUp>
          ))}
        </div>
      </div>

      {VERIFIED_TESTIMONIALS.length > 0 && (
        <div className="mt-20 grid grid-cols-1 gap-6 md:grid-cols-3" data-testid="testimonials">
          {VERIFIED_TESTIMONIALS.map((t, i) => (
            <blockquote key={i} className="rounded-3xl border border-mauve/35 bg-warmwhite p-8">
              <p className="font-serif text-xl italic text-plum">“{t.quote}”</p>
              <footer className="mt-4 text-sm font-semibold text-plumcharcoal/60">{t.name}</footer>
            </blockquote>
          ))}
        </div>
      )}
    </div>
  </section>
);
